import { ReactNode } from 'react'
import NavSidebar from './NavSidebar'
import styles from './AppShell.module.css'

interface AppShellProps {
  currentPage: string
  isAuthenticated: boolean
  isLoggedIn?: boolean
  children: ReactNode
}

export default function AppShell({ currentPage, isAuthenticated, isLoggedIn = false, children }: AppShellProps) {
  return (
    <div className={styles.shell}>
      <NavSidebar currentPage={currentPage} isAuthenticated={isAuthenticated} isLoggedIn={isLoggedIn} />
      <main className={styles.main}>
        {children}
      </main>
    </div>
  )
}
